module.exports = __webpack_public_path__ + "static/media/loginBg.933758c6.jpg";